export default __webpack_public_path__ + "static/media/icon-start-full.929c132c.svg";